import React from 'react';
import { Grid, Typography, TypographyVariant } from '@mui/material';
import useTitleWithPrintStyles from '../../styles/title-with-print/title-with-print.style';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import NavigationButton from '../navigation-button';

type Props = {
    variant?: TypographyVariant;
    title: string;
    titleClass?: string;
    children?: React.ReactNode;
    pdfUrl?: string;
    className?: string;
    isPrintingDisabled?: boolean;
};

export function TitleWithPrint(props: Props) {
    const classes = useTitleWithPrintStyles();
    const { t } = useTranslation();
    return (
        <>
            <Grid
                container
                justifyContent="space-between"
                className={clsx(classes.container, props.className)}
            >
                <Grid
                    item
                    xs={props.pdfUrl ? 8 : 12}
                    md={props.pdfUrl ? 9 : 12}
                >
                    <Typography
                        variant={props.variant ?? 'h2'}
                        className={props.titleClass ?? classes.title}
                    >
                        {props.title}
                    </Typography>
                    {props.children}
                </Grid>
                <Grid item>
                    {props.pdfUrl && (
                        <NavigationButton
                            href={props.pdfUrl}
                            label={t('visits.dialogHeader.print')}
                            disabled={props.isPrintingDisabled}
                        />
                    )}
                </Grid>
            </Grid>
        </>
    );
}
